export const SITE_PARAM_GROUPS = [
  {
    label: "Autopay",
    params: [
      { id: "AutopayPaymentIsActive", type: "boolean", valueKey: "valueBool" },
      { id: "AutopayPaymentUrl", type: "url", valueKey: "valueChar" },
      { id: "AutopayServiceId", type: "password", valueKey: "valueChar" },
      { id: "AutopaySharedKey", type: "password", valueKey: "valueChar" },
    ],
  },
  {
    label: "Elavon",
    params: [
      { id: "ElavonPaymentIsActive", type: "boolean", valueKey: "valueBool" },
      { id: "ElavonPaymentUrl", type: "url", valueKey: "valueChar" },
      { id: "ElavonMerchantAlias", type: "password", valueKey: "valueChar" },
      { id: "ElavonSecretKey", type: "password", valueKey: "valueChar" },
    ],
  },
  {
    label: "Płatności i faktury",
    params: [
      { id: "PaymentSupplier", type: "text", valueKey: "valueChar" },
      { id: "eInvoiceEmail", type: "email", valueKey: "valueChar" },
    ],
  },
];
